import { IonButton } from '@ionic/react'

import { useUpdateLoyaltyBonusRule } from '../../mutations'
import { BonusRule } from './bonus-rule'
import { EditBonusButton } from './edit-bonus-button'

import type { LoyaltyBonusRule } from '../../loyalty-bonus.schema'
import type { BonusAvailability } from './types'

type Props = {
  availability: BonusAvailability
  bonusRule: LoyaltyBonusRule
  canUpdateState?: boolean
  onDelete: () => void
  onEdit: () => void
}

function EditBonusRule({
  availability,
  bonusRule,
  canUpdateState,
  onDelete,
  onEdit,
}: Props) {
  const updateBonusRule = useUpdateLoyaltyBonusRule()

  return (
    <div className="grid grid-cols-[1fr_auto]">
      <BonusRule bonusRule={bonusRule} />
      {/* EDIT START */}
      <div className="space-x-2">
        {canUpdateState ? (
          <>
            {bonusRule.state === 'active' ? (
              <IonButton
                disabled={updateBonusRule.isLoading}
                size="small"
                onClick={() =>
                  updateBonusRule.mutate(
                    {
                      objectId: bonusRule.objectId,
                      state: 'stopped',
                    },
                    { onSettled: () => onEdit() }
                  )
                }
              >
                Stop
              </IonButton>
            ) : bonusRule.state === 'stopped' ? (
              <IonButton
                disabled={updateBonusRule.isLoading}
                size="small"
                onClick={() =>
                  updateBonusRule.mutate(
                    {
                      objectId: bonusRule.objectId,
                      state: 'active',
                    },
                    { onSettled: () => onEdit() }
                  )
                }
              >
                Start
              </IonButton>
            ) : null}
          </>
        ) : null}

        <EditBonusButton
          disabled={updateBonusRule.isLoading || bonusRule.state === 'active'}
          availability={availability}
          bonus={bonusRule}
          onSubmit={onEdit}
        />
        <IonButton
          disabled={updateBonusRule.isLoading}
          fill="outline"
          color="danger"
          size="small"
          onClick={onDelete}
        >
          Remove
        </IonButton>
      </div>
      {/* EDIT END */}
    </div>
  )
}

export { EditBonusRule }
